export default "__VITE_ASSET__b43715fe__$_?nuxt_component=async&nuxt_component_name=SvgoBedrock__"